import React from 'react'

import './style.css'

const TopLine = ({style}) => {
  return <div
  className="drift-widget-header-top-line"
  style={style}
  />
}

export default TopLine
